<template>
    <label class="w-6 h-6 inline-block relative rounded cursor-pointer border select-none bg-gray-200 border-gray-800 shadow-md"
           :class="{'border-error-500': error}">
        <input :disabled="disabled" class="opacity-0 w-0 h-0 absolute" type="checkbox" @change="changed($event)" :checked="getChecked()"/>
        <div class="mark absolute inset-0 rounded hover_bg-primary-200"></div>
    </label>
</template>
<script>
export default {
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        value: [Object, Array, Boolean, Number],
        error: Boolean,
        model: [Object, Array, Boolean, Number],
        disabled: {
            type: Boolean,
            default: false
        },
        text: String,
        isArray: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        // force empty array if null and isArray
        if (this.model == null && this.isArray) {
            this.$emit("change", [])
        }
    },
    methods: {
        getChecked() {
            if (Array.isArray(this.model)) {

                return this.model.indexOf(this.value) != -1
            }
            return this.model
        },
        changed(event) {
            var checked = event.srcElement.checked
            if (Array.isArray(this.model)) {
                if (checked) {
                    this.$emit('change', [this.value, ...this.model])
                } else {
                    this.model.splice(this.model.indexOf(this.value), 1)
                    this.$emit('change', this.model)
                }
                return
            }
            this.$emit("change", checked)
        }
    }
};
</script>
<style lang="scss" scoped>
.mark:after {
    width: 30%;
    height: 70%;
    content: " ";
    left: 35%;
    top: 8%;
    transform: rotate(45deg);
    @apply hidden absolute border-white border-r-2 border-b-2;
}

.mark:hover, input:focus ~ .mark {
    @apply shadow-outline outline-none;
}

input:checked ~ .mark:after {
    @apply block;
}

// special hover classes in theme.scss
</style>
